import React, { useState } from 'react';
import { Grid, Typography, Box } from '@mui/material';
import ProjectCard from '../components/ProjectCard';
import ProjectModal from '../components/ProjectModal';
import somcis1 from '../assets/projects/somcis1.jpeg';
import somcis2 from '../assets/projects/somcis2.jpeg';
import somcis3 from '../assets/projects/somcis3.jpg';
import somcis4 from '../assets/projects/somcis4.jpg';
import es1 from '../assets/projects/es1.jpeg';
import es2 from '../assets/projects/es2.jpeg';
import circle1 from '../assets/projects/circle1.jpeg';
import circle2 from '../assets/projects/circle2.jpeg';
import circle3 from '../assets/projects/circle3.jpg';
import circleFirstMeeting from '../assets/projects/circleFirstMeeting.pdf';
import theiaPitch from '../assets/projects/theiaPitch.pdf';
import theiaThumb from '../assets/projects/theiaThumb.jpg';
import theia1 from '../assets/projects/theia1.jpg';

const MILESTONES = [
  {
    title: 'Outstanding Student Award',
    description:
      'Recognized among the top 1% of engineering students at Tecnológico de Monterrey for impact across research, leadership, and innovation.',
    image: es1,
    gallery: [
      { original: es1, thumbnail: es1 },
      { original: es2, thumbnail: es2 },
    ],
    tag: 'Honors',
    year: '2024',
  },
  {
    title: 'Social Robotics for Autism Support',
    description:
      'Co-founded a robotics initiative that empowers children with autism spectrum disorder through social interaction therapies.',
    image: somcis2,
    gallery: [
      { original: somcis1, thumbnail: somcis1 },
      { original: somcis2, thumbnail: somcis2 },
      { original: somcis3, thumbnail: somcis3 },
      { original: somcis4, thumbnail: somcis4 },
    ],
    tag: 'Social Innovation',
    year: '2023',
  },
  {
    title: 'Circle · Blue Ocean Discovery Platform',
    description:
      'Co-founded Circle, a B2B SaaS startup that surfaces strategic partnerships and new market opportunities for corporate teams.',
    image: circle3,
    gallery: [
      { original: circle1, thumbnail: circle1 },
      { original: circle2, thumbnail: circle2 },
      { original: circle3, thumbnail: circle3 },
    ],
    slides: circleFirstMeeting,
    tag: 'Entrepreneurship',
    year: '2024',
  },
  {
    title: 'TheiaVision – Hult Prize Finalist',
    description:
      'Finalist at the Hult Prize Challenge Guadalajara with TheiaVision, a screening tool that helps prevent blindness in diabetic patients.',
    image: theia1,
    gallery: [
      { original: theiaThumb, thumbnail: theiaThumb },
      { original: theia1, thumbnail: theia1 },
    ],
    slides: theiaPitch,
    media: [
      'https://www.linkedin.com/posts/simon-amador_healthtech-healthtech-activity-7170447918171176960-Bq0R',
      'https://www.instagram.com/p/C5FRU0xuVo1/?igsh=Mmc0OXg5eGdiY2Fx',
    ],
    tag: 'Healthtech',
    year: '2024',
  },
  {
    title: 'FIRST Robotics - Two-Time National Champion',
    description:
      'Programmed in two robotics teams that won the national FIRST Robotics Competition, earning invitations to the world championship.',
    image: 'https://conecta.tec.mx/sites/default/files/inline-images/FIRST%20Laguna66.webp',
    gallery: [
      {
        original: 'https://conecta.tec.mx/sites/default/files/inline-images/FIRST%20Laguna66.webp',
        thumbnail: 'https://conecta.tec.mx/sites/default/files/inline-images/FIRST%20Laguna66.webp',
      },
    ],
    media: [
      'https://conecta.tec.mx/es/noticias/guadalajara/educacion/se-une-al-mundial-de-robotica-stingbots-6702-de-prepatec-santa-anita',
      'https://www.hidrocalidodigital.com/alumnos-de-prepa-tec-aguascalientes-ganan-su-pase-al-mundial-de-robotica/',
      'https://www.facebook.com/watch/?v=493793359116492',
    ],
    tag: 'STEM Leadership',
    year: '2018 - 2019',
  },
];

const Milestones = () => {
  const [open, setOpen] = useState(false);
  const [selectedMilestone, setSelectedMilestone] = useState(null);

  const handleLearnMore = (milestone) => {
    setSelectedMilestone(milestone);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedMilestone(null);
  };

  return (
    <Box>
      <Typography variant="overline" sx={{ color: 'secondary.light', letterSpacing: 2 }}>
        Moments that shaped my journey
      </Typography>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700 }}>
        Milestones
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 660, mb: 4 }}>
        Recognitions and entrepreneurial experiments that have fueled my focus on equitable
        innovation and community-centered outcomes.
      </Typography>

      <Grid container spacing={4}>
        {MILESTONES.map((milestone, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <ProjectCard
              {...milestone}
              onLearnMore={() => handleLearnMore(milestone)}
              outline
            />
          </Grid>
        ))}
      </Grid>

      <ProjectModal open={open} onClose={handleClose} project={selectedMilestone} />
    </Box>
  );
};

export default Milestones;
